import React, { useEffect } from "react";

export default function AboutUs() {
  useEffect(() => {
    document.title = "เกี่ยวกับเรา - สถาบันติวกฎหมาย";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-3">เกี่ยวกับเรา</h1>
            <p className="text-muted mb-4">
              ChicChic แหล่งเรียนรู้กฎหมายครบวงจร • บทความวิชาการ • วิดีโอความรู้ • คอร์สออนไลน์สอบราชการ
            </p>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">เราเป็นใคร</h2>
                <p>
                  <strong>เว็บไซต์ของเรา</strong> คือแพลตฟอร์มการเรียนรู้กฎหมาย
                  สำหรับผู้ที่ต้องการ <strong>เข้าใจกฎหมายอย่างเป็นระบบ</strong> และ
                  <strong>เตรียมตัวสอบ</strong> ทั้งสายกฎหมายและสายงานราชการ
                  โดยมีทีมงานติวเตอร์อาชีพที่มีประสบการณ์ดูแลเนื้อหาและการสอน
                </p>
                <p className="mb-0">
                  เราเชื่อว่าการเรียนกฎหมายไม่ควรยากเกินไป
                  หากมี “โครงสร้างที่ดี + ตัวอย่างที่ชัด + วิธีคิดที่ถูกต้อง”
                  จึงออกแบบเนื้อหาให้เรียนตามได้จริง ตั้งแต่พื้นฐานจนถึงระดับสอบแข่งขัน
                </p>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">เราโฟกัสเรื่องอะไร</h2>
                <ul>
                  <li>บทความวิชาการกฎหมาย: สรุปประเด็นสำคัญ อ่านเข้าใจง่าย</li>
                  <li>คลิปวิดีโอความรู้: อธิบายแนวคิด กรอบคิด และตัวอย่างการประยุกต์ใช้</li>
                  <li>คอร์สเรียนออนไลน์: เรียนเป็นลำดับ มีแบบฝึกหัด/แนวข้อสอบ (ตามคอร์ส)</li>
                  <li>แนวทางเตรียมสอบ: เทคนิคการทำข้อสอบ การวางโครงคำตอบ และทบทวนก่อนสอบ</li>
                </ul>
                <p className="mb-0">
                  เนื้อหาทั้งหมดถูกจัดทำให้ “กระชับ แต่ครบแก่น”
                  และสามารถนำไปใช้ได้ทั้งในการเรียน การทำงาน และการสอบ
                </p>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">ทีมติวเตอร์และมาตรฐานเนื้อหา</h2>
                <p>
                  ทีมของเราประกอบด้วย <strong>ติวเตอร์มืออาชีพ</strong> ที่มีประสบการณ์สอน
                  และคุ้นเคยกับแนวข้อสอบ
                  พร้อมกระบวนการตรวจทานเนื้อหาก่อนเผยแพร่ เพื่อความถูกต้องและความชัดเจน
                </p>
                <ul className="mb-0">
                  <li>สรุปแบบเป็นระบบ: หัวข้อ → ประเด็น → หลักกฎหมาย → ตัวอย่าง</li>
                  <li>เน้นความเข้าใจ ไม่ใช่ท่องจำอย่างเดียว</li>
                  <li>อัปเดตเนื้อหาให้เหมาะกับการสอบและการใช้งานจริง (ตามความเหมาะสม)</li>
                </ul>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">เรียนได้ทุกที่ ด้วยคอร์สออนไลน์</h2>
                <p>
                  คอร์สของเราถูกออกแบบให้เรียนได้สะดวกผ่านระบบสมาชิก
                  เหมาะสำหรับผู้เรียนที่ต้องการวางพื้นฐานให้แน่น
                  หรือเตรียมตัวสอบภายในเวลาที่จำกัด
                </p>
                <p className="mb-0">
                  คุณสามารถเลือกเรียนตามเป้าหมายของคุณได้ เช่น เรียนเป็นบท
                  ทบทวนก่อนสอบ หรือเรียนแบบเข้มข้นตามแผนที่คอร์สกำหนด
                </p>
              </div>
            </div>

            <div className="card border">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">เป้าหมายของเรา</h2>
                <ul>
                  <li>ทำให้การเรียนกฎหมายเป็นระบบและเข้าถึงได้ง่าย</li>
                  <li>ช่วยผู้เรียน “อ่านออก–คิดเป็น–เขียนได้” เพื่อใช้สอบและใช้จริง</li>
                  <li>ขยายคลังบทความ วิดีโอ และคอร์สให้ครอบคลุมหัวข้อสำคัญมากขึ้น</li>
                </ul>
                <p className="mb-0">
                  หากต้องการสอบถามข้อมูลคอร์ส แนะนำหัวข้อที่อยากให้ทำ
                  หรือแจ้งปัญหาการใช้งาน สามารถติดต่อเราได้ที่หน้า{" "}
                  <a href="/contact">ติดต่อเรา</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

